import type { SprintMission } from "@/campaigns/modules/sprint-mission/types";
import { CampaignJoinState } from "@/components/campaign-card/campaign-join-cta";
import { CampaignDockPanel } from "@/components/campaigns/campaign-shell/campaign-dock-panel";
import { FINISHED_DIM } from "@/components/campaigns/campaign-shell/campaign-view";
import { SprintMissionLatestWinsCard } from "./sprint-mission-latest-wins-card";
import { SprintMissionMissionCard } from "./sprint-mission-mission-card";
import { SprintMissionPayoutStrip } from "./sprint-mission-payout-strip";
import { SprintMissionStatusCard } from "./sprint-mission-status-card";
import { SprintMissionWinnersCard } from "./sprint-mission-winners-card";
import { useSprintMissionPhase } from "./use-sprint-mission-phase";

/**
 * A Sprint Mission in the overlay's dock column: the detail view's main column
 * at dock density — the player's outcome once there is one, the pool (winners
 * left), the join state, then the one prize and the tasks that win it, and
 * under them who won lately — the race the player is in, greyed as history
 * once it is over.
 */
export const SprintMissionDockPanel = ({
  sprintMission,
  joined,
}: {
  sprintMission: SprintMission;
  joined: boolean;
}) => {
  const phase = useSprintMissionPhase(sprintMission);

  return (
    <CampaignDockPanel minimumBet={sprintMission.minimum_bet}>
      <SprintMissionStatusCard sprintMission={sprintMission} />
      <SprintMissionPayoutStrip sprintMission={sprintMission} />
      <SprintMissionWinnersCard sprintMission={sprintMission} />
      {/* A drained pool is over for joining too, even while the status flip is a push away. */}
      {phase !== "finished" && (
        <CampaignJoinState campaign={sprintMission.campaign} joined={joined} />
      )}
      <SprintMissionMissionCard sprintMission={sprintMission} density="dock" />
      <div className={phase === "finished" ? FINISHED_DIM : undefined}>
        <SprintMissionLatestWinsCard
          sprintMission={sprintMission}
          density="dock"
        />
      </div>
    </CampaignDockPanel>
  );
};
